<template>
  <div>
    <v-app-bar app clipped-left elevation="1">
      <v-app-bar-nav-icon
        @click.stop="openDrawerClicked()"
      ></v-app-bar-nav-icon>
      <v-toolbar-title>
        <v-img width="120" src="kmitl_logo.png"></v-img>
      </v-toolbar-title>
      <v-app-bar-title
        class="deep-orange--text ml-2"
        v-if="!xs_only && route_name !== 'main_menu'"
      >
        {{ $t("app_bar.title") }}
      </v-app-bar-title>

      <v-spacer></v-spacer>

      <v-menu offset-y v-if="student_id">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            color="deep-orange"
            outlined
            dark
            v-bind="attrs"
            v-on="on"
            class="mr-3"
            dense
          >
            <span v-if="!xs_only">{{ student_name }}</span>
            <span v-else>{{ student_id }}</span>
            <v-icon>mdi-arrow-down-drop-circle-outline</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item>
            <v-list-item-title>
              <div class="text-center">
                {{ student_id }}
              </div>
            </v-list-item-title>
          </v-list-item>
          <v-list-item>
            <v-list-item-title>
              <v-btn
                text
                block
                class="red--text"
                v-if="officer_id"
                @click="logoutSurrogatedStudent()"
                >logout</v-btn
              >
              <v-btn text block class="red--text" v-else @click="logout()"
                >logout</v-btn
              >
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>

      <v-menu offset-y v-if="officer_id">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            color="deep-orange"
            outlined
            dark
            v-bind="attrs"
            v-on="on"
            class="mr-3"
            dense
          >
            <span v-if="!xs_only">{{ officer_name }}</span>
            <span v-else>{{ officer_id }}</span>
            <v-icon>mdi-arrow-down-drop-circle-outline</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item>
            <v-list-item-title>
              <v-btn text block class="red--text" @click="logout()"
                >logout</v-btn
              >
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>

      <v-btn
        color="deep-orange"
        outlined
        dark
        v-bind="attrs"
        v-on="on"
        class="mr-3"
        dense
        @click="login()"
        v-if="is_authen === false"
      >
        {{ $t("app_bar.login") }}
        <v-icon>mdi-login</v-icon>
      </v-btn>

      <v-btn
        color="deep-orange"
        outlined
        class="mr-3"
        @click="logout()"
        v-if="is_error"
      >
        Logout
        <v-icon size="x-large">mdi-logout</v-icon>
      </v-btn>

      <v-progress-circular
        indeterminate
        color="deep-orange"
        class="mr-3"
        :width="3"
        v-if="is_authen === null && is_error === false"
      ></v-progress-circular>

      <LanguageButton />
    </v-app-bar>
  </div>
</template>

<script>
import LanguageButton from "./LanguageButton";

export default {
  components: {
    LanguageButton,
  },
  data: () => ({
    on: null,
    attrs: null,
  }),
  computed: {
    is_authen() {
      return this.$store.state.user.is_authen;
    },
    is_error() {
      return this.$store.state.user.is_error;
    },
    officer_id() {
      if (this.$store.state.user.is_officer && this.$store.state.user.user_info)
        return this.$store.state.user.user_info.payload.ticket.user_id;
      return null;
    },
    officer_name() {
      if (this.$store.state.user.is_officer && this.$store.state.user.user_info)
        return (
          this.$store.state.user.user_info.fname_en +
          " " +
          this.$store.state.user.user_info.lname_en
        );
      return null;
    },
    student_id() {
      if (this.$store.state.user.surrogated_student_id)
        return this.$store.state.user.surrogated_student_id;
      return null;
    },
    student_name() {
      if (this.$store.state.user.surrogated_student_info)
        return (
          this.$store.state.user.surrogated_student_info.fname_en +
          " " +
          this.$store.state.user.surrogated_student_info.lname_en
        );
      return null;
    },
    xs_only() {
      return this.$vuetify.breakpoint.xsOnly;
    },
    route_name() {
      return this.$route.name;
    },
  },
  methods: {
    openDrawerClicked: function () {
      this.$emit("openDrawerClicked");
    },
    login() {
      this.$store.dispatch("keycloak/login");
    },
    logout() {
      this.$store.dispatch("user/logout");
    },
    logoutSurrogatedStudent() {
      this.$store.dispatch("user/logoutSurrogatedStudent");
    },
  },
};
</script>

<style lang="scss" scoped>
:deep(.v-app-bar-title__content) {
  width: 100% !important;
}
</style>
